import { LanguageDataType } from "../dtype/All";

export const LanguageData: LanguageDataType[] = [
  {
    code: "en",
    name: "English",
  },
];
